export default {
  kbInlineRelatedArticle: 'Related article:',
  kbInlineRelatedArticles: 'Related articles:',
};
